// import { RouterProvider } from "react-router-dom";
// import { router } from "./routes/router";

// export default function App() {
//   return <RouterProvider router={router} />;
// }
import { useCallback, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { ToastNotifications } from './components/Toast';
import { useToast } from './contexts/ContextoToast';
import { toastBridge } from './services/api/toast-bridge';
import { TourOverlay } from './shared/tour/TourOverlay';
import { VersionBanner } from './components/VersionBanner';
import { useVersionCheck } from './hooks/useVersionCheck';
import { KeyboardScopeProvider } from './lib/keyboard';
import './App.css';

function App() {
  const { toasts, removeToast, showError, showWarning } = useToast();
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  useEffect(() => {
    toastBridge.register(showError, showWarning);
  }, [showError, showWarning]);

  const handleNewVersion = useCallback(() => {
    setNewVersionAvailable(true);
  }, []);

  useVersionCheck(handleNewVersion);

  return (
    <KeyboardScopeProvider>
      <VersionBanner visible={newVersionAvailable} />
      <RouterProvider router={router} />
      <ToastNotifications toasts={toasts} onRemove={removeToast} />
      <TourOverlay />
    </KeyboardScopeProvider>
  );
}

export default App;
